<template>
	<select @change='change' v-model="selected" class='form-control my-control' :class='{"field-error": error}' :disabled='disabled'>
		<option v-for="option in options" :value='option.id' :disabled="option.id == 5" :key="option.id">
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const REASON = 'get_decision_reason.php'
	const CONCLUSION_INFO = 'get_conclusion_info.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'decisionReason',
		data: function () { 
			return {
				selected: '',
				options: [],
				savedOptions: [],
				savedId: ''
			}
		},
		props: {
			disabled: false,
			error: false
		},
		watch: {
			disabled: function(newVal, oldVal) {
				if(newVal)
				{
					this.savedOptions = this.options
					this.savedId = this.selected
					this.options = [{id:'', name:''}]
					this.selected = ''
				}
				else
				{
					this.options = this.savedOptions
					this.selected = this.savedId ? this.savedId : (this.options[0] ? this.options[0].id : '')
				}
				this.change()
			}
		},
		methods: {
			change () {
				EventBus.$emit(`decision_reason`, this.selected)
			}
		},
		mounted () {
			fetch(DB + CONCLUSION_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_42
			})
			.then(set_id => {
				fetch(DB + REASON, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.savedOptions = data
						this.options = set_id ? data : [{id:'', name:''}, ...data]
						this.selected = set_id ? set_id : ''
						this.savedId = this.selected
					}
					else {
						this.options = []
						this.selected = ''
					}
					this.change()
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		},
		created () {
			EventBus.$on('set_decision_reason', id => {
				this.selected = id
			})
		},
		beforeDestroy () {
			EventBus.$off('set_decision_reason')
		}
	}
</script>

<style scoped>
option[disabled] {
	background: #ccc;
}
</style>


// WEBPACK FOOTER //
// decisionReason.vue?17ef687c